<div class="table-container">
  <div class="tool-container">
    <div *ngIf="columnFilterConfig">
      <app-chip-selector
        (onSelectionChange)="
          applyColumnFilter($event, columnFilterConfig.field)
        "
        [chips]="columnFilterConfig.filterOptions"
        [multiple]="true"
      >
      </app-chip-selector>
    </div>
    <div class="tool-box-left-container">
      <div class="group-by-container" *ngIf="groupByConfig">
        <label class="group-by-label">
          <input #groupByCheckbox type="checkbox" (change)="onClickGroupBy()" />
          {{ 'qs-table.group_by' | translate }} {{ groupByConfig.displayName }}
        </label>
      </div>
      <div *ngIf="isSearchEnabled" class="search-container">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          placeholder="Search"
          [value]="searchText"
          (input)="onSearchInput($event)"
          class="custom-search"
          #searchInput
        />
      </div>
    </div>
  </div>

  <div class="table-scroll">
    <table
      mat-table
      [attr.data-testid]="testId || null"
      [dataSource]="dataSource"
      matSort
      multiTemplateDataRows
    >
      <!-- Define all normal columns -->
      <ng-container
        *ngFor="let col of columns"
        [matColumnDef]="getColumnDef(col)"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngStyle]="getHeaderCellStyle(col)"
          [mat-sort-header]="col.type === 'data' ? col.field : ''"
        >
          {{
            col.header
              ? col.header
              : col.type === 'data'
                ? (col.field | titlecase)
                : 'Actions'
          }}
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          [attr.data-testid]="getCellTestId(col, row)"
          [ngStyle]="getCellStyle(row, col)"
        >
          <ng-container *ngIf="col.type === 'data' && !col.customTemplate">
            <span (click)="handleDataCellClick(row, col)">
              <span
                class="qs-table-cell-text"
                [matTooltip]="getDataCellTooltip(row, col)"
                [matTooltipDisabled]="!getDataCellTooltip(row, col)"
                matTooltipShowDelay="200"
              >
                {{ getDataCellDisplayValue(row, col) }}
              </span>
            </span>
          </ng-container>
          <ng-container *ngIf="col.type === 'data' && col.customTemplate">
            <ng-container
              *ngTemplateOutlet="
                col.customTemplate;
                context: { $implicit: row }
              "
            ></ng-container>
          </ng-container>

          <ng-container
            *ngIf="col.type === 'action' && col.actionType === 'menu'"
          >
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              aria-label="Actions"
              [attr.data-testid]="
                getCellTestId(col, row)
                  ? getCellTestId(col, row) + '-button'
                  : null
              "
              (click)="$event.stopPropagation()"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <span
                *ngFor="let action of asActionMenuColumn(col).actions"
                class="action-menu-item-tooltip"
                [matTooltip]="getTableActionTooltip(action, row)"
                [matTooltipDisabled]="!getTableActionTooltip(action, row)"
              >
                <button
                  mat-menu-item
                  [attr.data-testid]="
                    action.testId && getCellTestId(col, row)
                      ? getCellTestId(col, row) + '-' + action.testId
                      : null
                  "
                  [disabled]="isTableActionDisabled(action, row)"
                  (click)="handleTableActionClick($event, action, row)"
                >
                  {{ action.label }}
                </button>
              </span>
            </mat-menu>
          </ng-container>

          <ng-container
            *ngIf="col.type === 'action' && col.actionType === 'button'"
          >
            <span
              *ngIf="col.iconName"
              class="action-button-tooltip"
              [matTooltip]="
                getActionButtonTooltip(asActionButtonColumn(col), row)
              "
              [matTooltipDisabled]="
                !getActionButtonTooltip(asActionButtonColumn(col), row)
              "
            >
              <button
                mat-icon-button
                [attr.aria-label]="col.buttonName"
                [attr.data-testid]="
                  getCellTestId(col, row)
                    ? getCellTestId(col, row) + '-button'
                    : null
                "
                (click)="
                  $event.stopPropagation();
                  asActionButtonColumn(col).buttonCallback(row)
                "
                [disabled]="
                  isActionButtonDisabled(asActionButtonColumn(col), row)
                "
              >
                <mat-icon fontSet="material-icons-outlined">{{
                  col.iconName
                }}</mat-icon>
              </button>
            </span>

            <span
              *ngIf="!col.iconName"
              class="action-button-tooltip"
              [matTooltip]="
                getActionButtonTooltip(asActionButtonColumn(col), row)
              "
              [matTooltipDisabled]="
                !getActionButtonTooltip(asActionButtonColumn(col), row)
              "
            >
              <button
                mat-button
                (click)="
                  $event.stopPropagation();
                  asActionButtonColumn(col).buttonCallback(row)
                "
                [disabled]="
                  isActionButtonDisabled(asActionButtonColumn(col), row)
                "
              >
                {{ col.buttonName }}
              </button>
            </span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Extra column for expansion toggle -->
      <ng-container *ngIf="expandable" matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="expand-cell">
            <button
              *ngIf="canExpand(row)"
              mat-icon-button
              (click)="toggleRow(row)"
            >
              <mat-icon>{{
                expandedElement === row ? 'expand_less' : 'expand_more'
              }}</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Define an extra column for the expandable detail row -->
      <ng-container matColumnDef="detail">
        <td
          mat-cell
          *matCellDef="let row"
          [attr.colspan]="columnKeysWithExpand.length"
        >
          <ng-container *ngIf="detailTemplate; else defaultDetail">
            <ng-container
              *ngTemplateOutlet="detailTemplate; context: { $implicit: row }"
            ></ng-container>
          </ng-container>
          <ng-template #defaultDetail>
            <div style="padding: 10px; background: lightgray">
              {{ row | json }}
            </div>
          </ng-template>
        </td>
      </ng-container>

      <!-- Header row -->
      <tr mat-header-row *matHeaderRowDef="columnKeysWithExpand"></tr>

      <!-- Normal data row -->
      <tr
        mat-row
        *matRowDef="let row; columns: columnKeysWithExpand"
        [attr.data-testid]="getRowTestId(row)"
        [ngStyle]="rowStyleFn ? rowStyleFn(row) : {}"
        [class.expanded]="expandedElement === row"
        [class.group-top]="isGroupByEnabled && row.isFirstInGroup"
        [class.group-bottom]="isGroupByEnabled && row.isLastInGroup"
        [class.clickable-row]="onRowClickFn"
        (click)="onRowClickFn?.(row)"
      ></tr>
      <!-- Row for "No entries found" when dataSource is empty -->
      <tr *matNoDataRow>
        <td [attr.colspan]="columns.length" class="no-data-row">
          {{ 'qs-table.no_data' | translate }}
        </td>
      </tr>

      <!-- Expandable detail row (Now correctly bound with multiTemplateDataRows) -->
      <tr
        mat-row
        *matRowDef="let row; columns: ['detail']"
        class="detail-row"
        [class.expanded]="expandedElement === row"
        [style.display]="
          expandedElement === row && canExpand(row) ? 'table-row' : 'none'
        "
      ></tr>
    </table>
  </div>
  <div class="qs-table-paginator" *ngIf="isPaginatorEnabled">
    <div class="qs-table-page-size">
      <span>{{ paginatorIntl.itemsPerPageLabel }}</span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-select
          [value]="selectedPageSize"
          (selectionChange)="onPageSizeChange($event.value)"
          [attr.aria-label]="paginatorIntl.itemsPerPageLabel"
        >
          <mat-option
            *ngFor="let pageSize of pageSizeOptions"
            [value]="pageSize"
          >
            {{ pageSize }}
          </mat-option>
          <mat-option value="all">{{ 'qs-table.all' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-paginator [hidePageSize]="true" [pageSize]="effectivePageSize">
    </mat-paginator>
  </div>
</div>
